module.exports = __webpack_public_path__ + "static/img/case2.02fad15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCase/case2.jpg
// module id = hjp3
// module chunks = 1